export const PRODUCT_IDS: {
  WPLC1: number;
  MARD: number;
  MCRP: number;
} = {
  WPLC1: 61,
  MARD: 96,
  MCRP: 97,
};
